// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");

function PropertyWizardRelay__Description__Subject(props) {
  var subject = props.subject;
  var match = PropertyWizardFormRelay.Context.use();
  var remainingChars = PropertyWizardFormRelay__Validators__Description.Subject.subjectLengthLimit - subject.valueAsString.length | 0;
  var tmp;
  var tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" || tmp$1.TAG !== "Rebroadcast" ? "For example: Remodeled home with level yard and ocean views" : "For example: Price reduction coming this week at Union SF";
  var match$1 = subject.focused;
  return JsxRuntime.jsxs(CssGrid.Cell, {
              width: 12,
              children: [
                JsxRuntime.jsx(Form__Input.make, {
                      labelText: "Headline",
                      placeholderText: tmp,
                      onChange: (function ($$event) {
                          var text = $$event.currentTarget.value;
                          subject.onChange(text);
                        }),
                      onBlur: (function (param) {
                          subject.onBlur();
                        }),
                      onFocus: (function (param) {
                          subject.onFocus();
                        }),
                      status: subject.status,
                      value: subject.valueAsString
                    }),
                JsxRuntime.jsx(Form__Components.FieldError.make, {
                      valid: subject.valid
                    }),
                match$1 && remainingChars <= 30 && remainingChars >= 0 ? JsxRuntime.jsx(FormV5.Warning.make, {
                        children: remainingChars.toString() + " characters remaining"
                      }) : null
              ]
            });
}

var Components;

var TextInputField;

var Cell;

var Validators;

var FormUtils;

var make = PropertyWizardRelay__Description__Subject;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.make = make;
/* FormV5 Not a pure module */
